<div class="fb-default-field-wrapper w-full">
  <div class="fb-field-label-container" *ngIf="!noLabel">
    <label *ngIf="label" class="fb-field-label">
      {{ label }}
      <span class="required-asterisk" *ngIf="required">*</span>
    </label>
  </div>

  <mat-form-field
    [appearance]="appearance || 'outline'"
    class="w-full fb-custom-outline"
    [class.is-invalid]="ngControl.control?.invalid && (ngControl.control?.touched || ngControl.control?.dirty)"
    [class.is-filled]="value !== null && value !== undefined && value !== ''"
  >
    <fb-anex
      *ngIf="prefix"
      matPrefix
      [config]="prefix"
      [control]="ngControl.control"
      [templates]="templates"
      position="start"
    ></fb-anex>

    <input
      [required]="required"
      matInput
      fbDisableAutocomplete
      [placeholder]="placeholder"
      [formControl]="autocompleteControl"
      [matAutocomplete]="auto"
      [fbDisableControl]="disable"
      [readonly]="readonly"
      #trigger="matAutocompleteTrigger"
      (blur)="onInputBlur()"
      (focusout)="onTouched()"
    />

    <ng-container *ngIf="(loading.active$ | async) === false; else showLoader">
      <ng-container *ngIf="suffix; else showButtons">
        <fb-anex
          matSuffix
          [config]="suffix"
          [control]="ngControl.control"
          [templates]="templates"
          position="end"
        ></fb-anex>
      </ng-container>
      <ng-template #showButtons>
        <div matSuffix class="actions-suffix-container">
          <ng-container *ngIf="allowEmpty && value !== undefined && value !== null && value !== '' && !disable">
            <button
              tabindex="-1"
              type="button"
              mat-icon-button
              class="action-btn"
              (click)="onClear(); onTouched(); trigger.closePanel(); $event.stopPropagation(); $event.preventDefault()"
              [disabled]="disable || readonly"
            >
              <mat-icon [inline]="true" class="icon-button">clear</mat-icon>
            </button>

            <div class="action-divider"></div>
          </ng-container>
          <button
            type="button"
            mat-icon-button
            class="action-btn arrow-icon"
            (click)="
              trigger.panelOpen ? trigger.closePanel() : trigger.openPanel();
              $event.stopPropagation();
              $event.preventDefault()
            "
            [disabled]="disable || readonly"
          >
            <mat-icon [inline]="true" class="icon-button">unfold_more</mat-icon>
          </button>
        </div>
      </ng-template>
    </ng-container>
    <ng-template #showLoader>
      <fb-loader class="position-relative loader" [size]="20" [message]="undefined" matSuffix></fb-loader>
    </ng-template>

    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayValue">
      <ng-container *ngFor="let group of filteredValues$ | async">
        <ng-container *ngIf="group; else showNoData">
          <div class="disabled-option" *ngIf="group.groupLabel" [title]="group.groupLabel">
            <div class="d-flex align-items-center w-full group-name">
              {{ group.groupLabel }}
            </div>
          </div>

          <mat-option *ngFor="let option of group.options" [value]="option" [title]="option.label">
            <div class="d-block truncate" [class.pl-8]="group.groupLabel">
              {{ option.label }}
            </div>
          </mat-option>
        </ng-container>
        <ng-template #showNoData>
          <mat-option [disabled]="true">
            <div class="text-center not-found">Not found</div>
          </mat-option>
        </ng-template>
      </ng-container>
    </mat-autocomplete>
  </mat-form-field>

  <div class="fb-field-subscript-absolute">
    <fb-validation-error
      *ngIf="
        ngControl.control?.invalid &&
        (ngControl.control?.touched || ngControl.control?.dirty) &&
        (loading.active$ | async) === false
      "
      [control]="ngControl.control"
      [label]="label"
    ></fb-validation-error>
  </div>
</div>
